import { render, staticRenderFns } from "./list-v-rank.vue?vue&type=template&id=37082c7c&scoped=true"
import script from "./list-v-rank.vue?vue&type=script&lang=js"
export * from "./list-v-rank.vue?vue&type=script&lang=js"
import style0 from "./list-v-rank.vue?vue&type=style&index=0&id=37082c7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37082c7c",
  null
  
)

export default component.exports